//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'register',
    user: "",
    data() {

        return {
            user: {},
            rules: {
                username: [
                    { required: true, message: '请输入qq号或者电话号作为账号', trigger: 'blur' },
                    { min: 10, max: 11, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { min: 8, message: '长度最小为8', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },],
                password: [
                    { required: true, message: '请输入密码，长度最小为6', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ],
            }
        }
    },

    methods: {

        sendEmailCode(type) {
            let email;
            if (type === 1) {
                email = this.user.email
            } else if (type === 2) {
                email = this.pass.email
            }
            if (!email) {
                this.$message.warning("请输入邮箱账号")
                return
            }
            if (!/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(email)) {
                this.$message.warning("请输入正确的邮箱账号")
                return
            }
            // 发送邮箱验证码
            this.request.get("/user/email/" + email + "/" + type).then(res => {
                if (res.code === '200') {
                    this.$message.success("发送成功")
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        login() {
            this.$refs['userForm'].validate((valid) => {
                if (valid) {  // 表单校验合法
                    if (this.user.password !== this.user.confirmPassword) {
                        this.$message.error("两次输入的密码不一致")
                        return false
                    }
                    this.request.post("/user/forget", this.user).then(res => {
                        if (res.code === '200') {
                            this.$message.success("注册成功")
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            });
        }
    }
}
